import React, { useEffect, useState } from 'react';
import '../Estilos/TextInput.css';
import '../Estilos/Fontes.css';
import '../Estilos/Componentes.css';

function TextInput({
  largura = '100%',
  titulo,
  erro = false,
  erroTexto = '',
  tipo = 'text',
  placeholder = '',
  padrao = '',
  top = '0',
  keyTrigger = false,
  disabled = false,
  color = '',
  maxLength = null,
  minValue = null,
  maxValue = null,
  onEnter = () => {},
  onUpdate = () => {},
}) {
  const [passwordIcon, setPasswordIcon] = useState(tipo === 'password' ? require('../Icones/eye-on.svg').default : require('../Icones/eye-off.svg').default);
  const [inputType, setInputType] = useState(tipo);

  useEffect(() => {
    if (tipo === 'password') {
      setInputType('password');
      setPasswordIcon(require('../Icones/eye-on.svg').default);
    } else {
      setInputType(tipo);
      setPasswordIcon(require('../Icones/eye-off.svg').default);
    }
  }, [tipo]);

  const togglePasswordVisibility = () => {
    if (inputType === 'password') {
      setInputType('text');
      setPasswordIcon(require('../Icones/eye-off.svg').default);
    } else {
      setInputType('password');
      setPasswordIcon(require('../Icones/eye-on.svg').default);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: largura, paddingTop: top, minWidth: '100px' }}>
      <h3 id="TituloInput" style={{ color: (color ? color : '') }}>{titulo}</h3>
      <div style={{ display: 'flex', width: '100%', border: '1px solid #E0E0E0', borderRadius: 5 }}>
        <input
          id="Input"
          type={inputType}
          value={padrao}
          placeholder={placeholder}
          onChange={(e) => onUpdate(e.target.value)}
          onKeyDown={(e) => keyTrigger && e.key === 'Enter' && onEnter()}
          disabled={disabled}
          style={{ color: (color ? color : '') }}
          maxLength={maxLength ?? null}
          min={minValue ?? null}
          max={maxValue ?? null}
        />
        {tipo === 'password' && !disabled && (
          <img
            style={{ cursor: 'pointer', paddingRight: 8 }}
            src={passwordIcon}
            alt="Toggle visibility"
            onClick={togglePasswordVisibility}
          />
        )}
      </div>
      {erro && (
        <div
          style={{
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingTop: 8,
          }}
        >
          <img src={require('../Icones/block.svg').default} alt="block" />
          <h4
            style={{
              color: 'red',
              fontSize: 12,
              padding: 0,
              margin: 0,
              verticalAlign: 'center',
              paddingLeft: 8,
              fontFamily: 'montserrat',
              fontWeight: 500,
            }}
          >
            {erroTexto}
          </h4>
        </div>
      )}
    </div>
  );
}

function FixedInput({
  largura = '100%',
  titulo,
  padrao = '',
  top = '0',
  right = '0',
  left = '0',
  disabled = false,
  tipo = 'text',
}) {

  const [inputType, setInputType] = useState(tipo);

  useEffect(() => {
    setInputType(tipo);
  }, [tipo]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: largura,
        paddingTop: top,
        // paddingLeft: 20,
        // paddingRight: 20,
        marginRight: right,
        marginLeft: left,
      }}
    >
      <h3 id="TituloInput">{titulo}</h3>
      <div style={{ display: 'flex', width: '100%', border: '1px solid #E0E0E0', borderRadius: 5 }}>
        <input id="Input" type={inputType} defaultValue={padrao} disabled={disabled} />
      </div>
    </div>
  );
}

function SublinhadoInput({
  largura = '100%',
  titulo,
  top = '0',
  foraSpec = false,
  padrao = '',
  unidade = '',
  disabled = false,
}) {
  const colorStyle = foraSpec ? { color: 'red' } : {};
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: largura, paddingTop: top }}>
      <h3 id="TituloInput" style={colorStyle}>
        {titulo}
      </h3>
      <div style={{ display: 'flex', width: '100%', borderBottom: '1px solid #E0E0E0' }}>
        <input
          id="Input"
          type="text"
          style={{ ...colorStyle, opacity: disabled ? 0.5 : 1 }}
          value={padrao + ' ' + unidade}
          readOnly
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default TextInput;
export { FixedInput, SublinhadoInput };
